module.exports = require('./helpers/bundle-url').getBundleURL('9rAa3') + "default_left.dfc31853.svg";